import emptySliceApi from '../../../../shared/store/emptyApiSlice';
import { InternalAdminModel } from './models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getInternalAdmins: builder.query<InternalAdminModel[], string>({
      query: () => `/v4/poweradmins`,
      providesTags: ['Admin', 'User'],
    }),
    resendInternalAdminInvitation: builder.mutation<
      any,
      { inviteCode: string }
    >({
      query: ({ inviteCode }) => ({
        url: `v4/poweradmins/invite/${inviteCode}/resend`,
        method: 'POST',
      }),
      invalidatesTags: ['Admin', 'User'],
    }),
  }),
});

export const {
  useGetInternalAdminsQuery,
  useResendInternalAdminInvitationMutation,
} = apiSlice;
